// Expanded with the new dropdown options
const colorHexMap = {
    // Original Swatch Colors
    "Gold": ["#FFD700", "#000000"],
    "Silver": ["#C0C0C0", "#000000"],
    "Bronze": ["#CD7F32", "#000000"],
    
    // New Polydomed Plate Colors
    "Black with White Letters": ["#000000", "#FFFFFF"],
    "Blue with White Letters": ["#0000FF", "#FFFFFF"],
    "Red with White Letters": ["#FF0000", "#FFFFFF"],
    "Purple with White Letters": ["#800080", "#FFFFFF"],
    "Gold with Black Letters": ["#FFD700", "#000000"],
    "Silver with Black Letters": ["#C0C0C0", "#000000"],
    "White with Black Letters": ["#FFFFFF", "#000000"],
    "Yellow with Black Letters": ["#FFFF00", "#000000"]
};

let bgHex = null;
let fontHex = null;

// ========================================================
// 1. Delegate Color & Price Changes Globally
// ========================================================
function applyColors(colorName) {
    if (!colorName) return;
    colorName = colorName.trim();
    
    if (colorHexMap[colorName]) {
        bgHex = colorHexMap[colorName][0];
        fontHex = colorHexMap[colorName][1];

        document.querySelectorAll(".color_showcase").forEach(showcase => {
            showcase.style.backgroundColor = bgHex;
        });

        const previews = document.querySelectorAll(".engraving_preview");
        if (previews.length > 0) {
            previews.forEach(pr => {
                pr.style.setProperty('background-color', bgHex, 'important');
                pr.style.setProperty('color', fontHex, 'important');
            });
        }
    }
}

// Attach listeners to the document so they survive form re-renders
document.addEventListener("change", (e) => {
    // Catch Variant Swatch changes
    if (e.target.matches("fieldset.variant-option--swatches input[type='radio']")) {
        applyColors(e.target.value);
    }
    
    // NEW: Catch Polydomed Plate Dropdown changes
    if (e.target.matches("select[aria-label='Color of Polydomed Plate']")) {
        applyColors(e.target.value);
    }
    
    // Catch Price Tier variant changes
    if (e.target.matches(".variant-input-wrap .variant-input input")) {
        const qtyInput = document.querySelector("input[name='quantity']");
        const qty = qtyInput ? qtyInput.value : 1;
        setTimeout(() => updatePrices(qty), 50);
    }
});

// ========================================================
// 2. Watch for Form Re-renders
// ========================================================
// This automatically fires on initial load AND anytime the theme re-renders the form
const initObserver = new MutationObserver(() => {
    const engravingOption = document.querySelector(".hulkapps_option.rb_render > div[aria-label='Engraving'] + div input[type='hidden']");
    
    // Check if it exists and hasn't been initialized by us yet
    if (engravingOption && !engravingOption.dataset.customized) {
        engravingOption.dataset.customized = "true"; 
        initEngravingLogic(engravingOption);
    }
});

initObserver.observe(document.documentElement, { childList: true, subtree: true });

// ========================================================
// 3. Core Initialization Logic
// ========================================================
function initEngravingLogic(engravingOption) {
    // 3a. Immediately apply colors from the currently checked variant...
    const activeVariant = document.querySelector("fieldset.variant-option--swatches input[type='radio']:checked");
    if (activeVariant) {
        applyColors(activeVariant.value);
    }
    
    // ... OR from the newly added Polydomed Plate dropdown if it has a pre-selected value on load
    const activeDropdown = document.querySelector("select[aria-label='Color of Polydomed Plate']");
    if (activeDropdown && activeDropdown.value) {
        applyColors(activeDropdown.value);
    }

    // 3b. Setup Engraving toggle observer
    const observer = new MutationObserver(() => {
        const engravingTitle = document.querySelector(".engraving_title");
        const container = document.querySelector(".engraving_container");
        
        if (engravingOption.getAttribute("value").includes("Different")) {
            if (container) container.style.display = "block";
            document.querySelectorAll(".engraving_repeat").forEach(rpt => rpt.style.display = "block");

            if (engravingTitle) {
                engravingTitle.textContent = "Engraving 1 of 1";
                engravingTitle.style.display = "block";
            }
        } else {
            if (container) container.style.display = "none";
            document.querySelectorAll(".engraving_repeat").forEach(rpt => rpt.style.display = "none");

            if (engravingTitle) {
                engravingTitle.textContent = "Engraving for All";
                engravingTitle.style.display = "block";
            }
        }
    });

    observer.observe(engravingOption, { attributes: true, attributeFilter: ["value"] });

    // 3c. Setup DOM structures
    const form = engravingOption.closest("form");
    if (!form) return;
    const optionSet = form.querySelector(".hulkapps_option_set");
    if (!optionSet) return;

    const engravingContainer = document.createElement("div");
    engravingContainer.className = "engraving_container";
    optionSet.appendChild(engravingContainer);

    const quantityInput = form.querySelector("input[name='quantity']");
    if (quantityInput) {
        quantityInput.addEventListener("change", e => {
            const engravingDifferentList = optionSet.querySelectorAll(".engraving_different");
            const len = engravingDifferentList.length / 3 + 1;

            if (e.target.value == len) return;
            else if (e.target.value > len) {
                document.querySelectorAll(".engraving_title").forEach((title, i) => {
                    title.textContent = `Engraving ${i + 1} of ${e.target.value}`;
                });
                createNewEngravingOptions(engravingContainer, e.target.value - len, e.target.value, len);
            } else {
                deleteExistingEngravingOptions(engravingContainer, len - e.target.value, e.target.value, len);
            }

            updatePrices(e.target.value);
        });
    }

    const engravingLineList = optionSet.querySelectorAll(".hulkapps_option.tb_render:has(div[aria-label^='Line'])");
    engravingLineList.forEach((element, index) => {
        if (index === 0) {
            const newOptionTitle = document.createElement("h2");
            newOptionTitle.textContent = "Engraving for All";
            newOptionTitle.className = "engraving_title";
            element.parentElement.insertBefore(newOptionTitle, element);
        }

        const newEngravingPreview = document.createElement("div");
        newEngravingPreview.className = `engraving_preview engraving_preview_${index + 1}`;
        
        // Ensure preview has background on load
        if (bgHex && fontHex) {
            newEngravingPreview.style.setProperty('background-color', bgHex, 'important');
            newEngravingPreview.style.setProperty('color', fontHex, 'important');
        }
        element.appendChild(newEngravingPreview);

        const inputField = element.querySelector("input[type='text']");
        if (inputField) {
            // Pre-fill if there's already text inside
            newEngravingPreview.textContent = inputField.value;
            inputField.addEventListener("input", e => {
                newEngravingPreview.textContent = e.target.value;
            });
        }

        const newRepeatBtn = document.createElement("button");
        newRepeatBtn.textContent = "Repeat";
        newRepeatBtn.className = "engraving_repeat";
        newRepeatBtn.setAttribute("data-active", "false");
        
        const valueContainer = element.querySelector(".hulkapps_option_value");
        if (valueContainer) valueContainer.appendChild(newRepeatBtn);

        newRepeatBtn.addEventListener("click", e => {
            e.preventDefault();

            const val = inputField ? inputField.value : "";
            if (e.target.getAttribute("data-active") == "true") {
                document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div input`).forEach(input => {
                    input.value = "";
                });
                document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div + div`).forEach(preview => {
                    preview.textContent = "";
                });
                e.target.setAttribute("data-active", "false");
            } else {
                document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div input`).forEach(input => {
                    input.value = val;
                });
                document.querySelectorAll(`.hulkapps_option.engraving_different > .hulkapps_option_name[aria-label="Line ${index + 1}"] + div + div`).forEach(preview => {
                    preview.textContent = val;
                });
                e.target.setAttribute("data-active", "true");
            }
        });
    });

    handleColorSelect();

    setTimeout(() => {
        const qtyInput = document.querySelector("input[name='quantity']");
        if (qtyInput) updatePrices(qtyInput.value);
    }, 50);
}

// ========================================================
// Helper Functions 
// ========================================================
function createNewEngravingOptions(optionSet, num, quantity, len) {
    for (let i = 0; i < num; i++) {
        for (let j = 0; j < 3; j++) {
            const wrapper = document.createElement("div");
            wrapper.className = "hulkapps_option tb_render full_width engraving_different";

            if (j === 0) {
                const newOptionTitle = document.createElement("h2");
                newOptionTitle.textContent = `Engraving ${len + i + 1} of ${quantity}`;
                newOptionTitle.className = "engraving_title";
                newOptionTitle.style.display = "block";
                wrapper.appendChild(newOptionTitle);
            }

            const labelDiv = document.createElement("div");
            labelDiv.className = "hulkapps_option_name";
            labelDiv.setAttribute("aria-label", `Line ${j + 1}`);
            labelDiv.setAttribute("tabindex", "0");
            labelDiv.setAttribute("aria-required", "false");

            const labelInner = document.createElement("div");
            labelInner.textContent = `Line ${j + 1}`;

            labelDiv.appendChild(labelInner);

            const valueDiv = document.createElement("div");
            valueDiv.className = "hulkapps_option_value";

            const input = document.createElement("input");
            input.type = "text";
            input.className = "hulkapps_option_child hulk_po_other_options hulkapps_full_width price-change";
            input.setAttribute("data-parent", "hulkapps_product_options");
            input.setAttribute("data-pid", "8570396704935");
            input.setAttribute("data-price", "0.00");
            input.maxLength = 16;
            input.addEventListener("input", e => {
                newEngravingPreview.textContent = e.target.value;
            });

            const hidden1 = document.createElement("input");
            hidden1.type = "hidden";
            hidden1.name = `properties[Line ${j + 1}_${len + i + 1}]`;
            hidden1.className = "tb_property_val other_options_prop_val";

            const hidden2 = document.createElement("input");
            hidden2.type = "hidden";
            hidden2.value = "16";
            hidden2.className = "character_count";

            const charCount = document.createElement("div");
            charCount.id = "char_count_1604792";
            charCount.textContent = "16 Characters remaining";

            const script = document.createElement("script");
            script.textContent = `(function($) {
                $(document).on('input', '.hulkapps_product_options .hulkapps_option_1604792', function() {
                    check_character_limit(16,'1604792','Characters remaining','hulkapps_product_options');
                });
                }(hulkapps_jQuery))`;

            const newEngravingPreview = document.createElement("div");
            newEngravingPreview.className = `engraving_preview engraving_preview_${j + 1}`;
            
            // Maintain colors on dynamic generation
            if (bgHex && fontHex) {
                newEngravingPreview.style.setProperty('background-color', bgHex, 'important');
                newEngravingPreview.style.setProperty('color', fontHex, 'important');
            }

            valueDiv.appendChild(input);
            valueDiv.appendChild(hidden1);
            valueDiv.appendChild(hidden2);
            valueDiv.appendChild(charCount);
            valueDiv.appendChild(script);

            wrapper.appendChild(labelDiv);
            wrapper.appendChild(valueDiv);

            wrapper.appendChild(newEngravingPreview);
            optionSet.appendChild(wrapper);
        }
    }
}

function deleteExistingEngravingOptions(optionSet, num) {
    const engravingDifferentList = optionSet.querySelectorAll(".engraving_different");
    const toRemove = num * 3;

    for (let i = 0; i < toRemove; i++) {
        const last = engravingDifferentList[engravingDifferentList.length - 1 - i];
        if (last) last.remove();
    }
}

function getDiscountedPrice(quantity) {
    const tierElements = document.querySelectorAll(".variant-input-wrap .variant-input:has(input:checked) + div > div");

    for (const el of tierElements) {
        const lines = el.innerText.trim().split("\n").map(t => t.trim());
        if (lines.length < 2) continue;

        const rangeText = lines[0]; 
        const priceText = lines[1]; 

        const price = parseFloat(priceText.replace("$", ""));
        let min, max;

        if (rangeText.includes("-")) {
            const [low, high] = rangeText.split("-").map(Number);
            min = low;
            max = high;
        } else if (rangeText.includes("+")) {
            min = parseInt(rangeText);
            max = Infinity;
        } else {
            min = parseInt(rangeText);
            max = min;
        }

        if (quantity >= min && quantity <= max) {
            return price * quantity;
        }
    }

    return null;
}

function updatePrices(quantity) {
    const price = getDiscountedPrice(quantity);
    
    const atcBtn = document.querySelector(".add-to-cart.hulkapps_submit_cart span");
    if (!atcBtn) return;
    
    const money = atcBtn.querySelector("span.money");
    if (money) {
        money.textContent = formatPrice(price);
    } else {
        atcBtn.innerHTML += `<span>●</span><span class="money">${formatPrice(price)}</span>`;
    }
}

function formatPrice(price) {
    return price.toLocaleString(Shopify.locale + '-' + Shopify.country, {
        style: 'currency',
        currency: Shopify.currency.active
    }).replace(/^.*\$/, "$");
}

function handleColorSelect() {
    // const hulkSwatchesList = document.querySelectorAll(".hulkapps_option_set div[aria-label='Color'] + div label");
    // const shopifySwatchesList = document.querySelectorAll("variant-selects .swatch-item input");
    
    // hulkSwatchesList.forEach(hulkSwatch => {
    //     hulkSwatch.addEventListener("click", e => {
    //         if (e.target.value) {
    //             shopifySwatchesList.forEach(shopifySwatch => {
    //                 if (shopifySwatch.value == e.target.value) {
    //                     shopifySwatch.click();
    //                     return;
    //                 }
    //             });
    //         }
    //     });
    // });
}

setTimeout(function(){
    const parentOption = document.querySelector("#Engraving-option-parent")?.closest(".hulkapps_option");
    
    const engravingContainer = document.querySelector(".engraving_container");

    if (parentOption && engravingContainer) {
        parentOption.insertAdjacentElement("afterend", engravingContainer);
    }
},1000);